import {
  saveListDocuments,
  saveCountDocuments,
  saveSelectedDocument,
} from "../Infrastructure/Documents.store";
import {
  getUserDocumentsLogic,
  getDocumentByIdLogic,
  getDocumentsByUserLogic
} from "./Documents.logic";

export async function getUserDocuments(params) {
  const { resources, count } = await getUserDocumentsLogic(params);
  saveListDocuments(resources);
  saveCountDocuments(count);
}

export async function getDocumentById(id) {
  const doc = await getDocumentByIdLogic(id);
  saveSelectedDocument(doc);
}

export async function getDocumentsByUser(params) {
  console.log("getDocumentsByUser called with params:", params);
  try {
    const { resources, count } = await getDocumentsByUserLogic(params);
    saveListDocuments(resources);
    saveCountDocuments(count);
  } catch (err) {
    console.error("Error in getDocumentsByUser:", err);
    console.error("Error details:", {
      message: err.message,
      error_data: err.error_data,
      response: err.response,
    });
    throw err;
  }
}
